<template>
	<div class="main" :class='{list_wrapper: currentPath == "list" || currentPath == "drafts" || currentPath == "states" || currentPath == "decisions"}'>
		<navbar placement='top' type='inverse'>
			<!-- <a slot="brand" href="#/main" class="navbar-brand">Реестр актов</a>
			<li v-if='can_create_act'  :class='{underlined: currentPath == "add"}'>
				<a href='#/main/add' class='collapse'>Новый акт</a> 
			</li>-->

			<dropdown v-if='can_create_act' text='Новый акт' :class='{underlined: isReport}'>
				<li><a href='#/main/add' class='collapse'>Создать</a></li>
				<li>
					<a href='#' @click.prevent="importAct" class='collapse'>Импортировать</a>
					<input type="file" accept="text/xml" ref="xml_input" class="xml_input" @change="changeXmlFile">
				</li>
			</dropdown>	

			<dropdown text='Редактировать' :class='{underlined: currentPath == "edit" || currentPath == "conclusion" || currentPath == "warrant"}'>
				<li><a :href="editPath">Акт ЛПО</a></li>
				<li><a :href="conclusionPath">Заключение на Акт ЛПО</a></li>
				<li><a :href="warrantPath">Документарная проверка</a></li>
				<li><a :href="supervisionPath">Взаимодействие с надзорными органами</a></li>
				<li v-if='canEditWarrant'><a href="#/main/warrant_group">Документарная проверка на группу актов</a></li>
				<li v-if='canDeleteAct && currentPath == "list"'><a href="#" @click.prevent="deleteAct">Удалить</a></li>
			</dropdown>

			<dropdown text='Группировка' :class='{underlined: currentPath == "group_conclusion"}' :disabled='groupDisabled'>
				<li><a @click='makeGroup'>Сгруппировать</a></li>
				<li :class="{ 'disabled': makeGroupFromFilterDisabled }"><a @click='makeGroupFromFilter'>Сгруппировать отфильтрованные</a></li>
				<li class='disabled'><a>Разгруппировать</a></li>
				<li v-if='currentPath == "group_conclusion"'><a @click='showSimilarActs'>Редактировать группу</a></li>
			</dropdown>

			<dropdown text='Реестры' :class='{underlined: currentPath == "list" || currentPath == "drafts" || currentPath == "states" || currentPath == "decisions" || currentPath == "supervisory"}'>
				<li><a href="#/main">Реестр актов</a></li>
				<li><a href="#/main/drafts">Реестр черновиков</a></li>
				<li><a href="#/main/states">Реестр состояний</a></li>
				<li><a href="#/main/decisions">Реестр результатов оценки актов ЛПО</a></li>
				<li><a href='#/main/supervisory'>Реестр взаимодействия</a></li>
			</dropdown>

			<li class="divider"></li>

			<template v-if='canEditReports'>
				<dropdown text='Отчёты' :class='{underlined: isReport}'>
					<li><a href='#/main/reports'>Отчёты</a></li>
					<li><a href='#' @click.prevent='showEditReportsModal = true'>Управление отчётами</a></li>
				</dropdown>
			</template>
			<template v-else>
				<li v-if='reports.length' :class='{underlined: isReport}'>
					<a href='#/main/reports' class='collapse'>Отчёты</a>
				</li>
			</template>

			<li v-if='can_reg_user' :class='{underlined: currentPath == "reg"}'>
				<a href='#/main/reg' class='collapse'>Регистрация</a>
			</li>	

			<!-- <li>
				<a @click='generate_conclusion' class='collapse pointer' v-if='displayTheConclusion'>Заключение на акт</a>
			</li> -->

			<dropdown v-if='displayTheConclusion' text='Заключение'>
				<li><a @click='generate_conclusion'>Заключение на акт</a></li>
				<li><a @click="get_possible_conclusion_for_group">Заключение на группу актов</a></li>
			</dropdown>

			<li v-if='can_save_db'>
				<a :href="db + 'db_to_csv.php'" target="_blank" class='collapse pointer'>Выгрузка базы</a>
			</li>

			<li v-if='canEditAddress'>
				<a href='#/main/catalog' class='collapse'>Справочник</a>
			</li>
			
			<!-- <dropdown text='Отчёты'>
				<li><a @click="showWeekModal = true" href="#">Мониторинг актов ЛПО</a></li>
				<li><a @click="showConclusionModal = true" href="#">Сведения по заключениям</a></li>
			<li><a class='disabled-link'@click="showSomModal = true" href="#">Сведения о назначенных мероприятиях</a></li>
				<li><a class='disabled-link'@click="doNothing" href="#">Сведения о назначенных мероприятиях</a></li>
			</dropdown> -->

			<!-- <li>
				<a href="#">Удалить</a>
			</li> -->
			
			<li slot="right">
				<a href="#" @click.prevent="showUserModal = true" class="navbar-brand">{{user_name}} <span class="caret"></span></a>
			</li>
			<li slot="right" style="margin-left: 20px">
				<a href="#" @click.prevent="showHelpModal = true" class="navbar-brand"><i>Справка</i></a>
			</li>

		</navbar>
		<router-view></router-view>

		<div class='loading-wrap' v-if='loading'>
			<i class='fa fa-spinner fa-spin' style='font-size:48px;'></i>
		</div>

		<modal title='Выберите действие' v-model="showUserModal" @ok="showUserModal = false" @closed='clearModal' :backdrop='false' small>
			<tabs v-model='activeTab' nav-style='tabs'>
				<tab header='Выход'>
					<div class="row">
						<div class="col-md-12 center large-font">
							<span class="bold">{{user_name}}</span>
						</div>
					</div>
				</tab>
				<tab header='Сменить пароль' :disabled='can_change_pass'>
					<div class="row">
						<div class="col-md-12 center">
							<label>Старый пароль</label>
						</div>
					</div>
					<div class="row" :class='old_password.status'>
						<div class="col-md-12">
							<input type="password" v-model="old_password.value" class="form-control" required>
							<span v-if='old_password.status == "has-error"' class="glyphicon glyphicon-remove form-control-feedback"></span>
							<span v-if='old_password.status == "has-success"' class="glyphicon glyphicon-ok form-control-feedback"></span>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 center">
							<label>Новый пароль</label>
						</div>
					</div>
					<div class="row" :class='new_password.status'>
						<div class="col-md-12">
							<input type="password" v-model="new_password.value" class="form-control" required>
							<span v-if='new_password.status == "has-error"' class="glyphicon glyphicon-remove form-control-feedback"></span>
							<span v-if='new_password.status == "has-success"' class="glyphicon glyphicon-ok form-control-feedback"></span>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 center">
							<label>Повторите новый пароль</label>
						</div>
					</div>
					<div class="row" :class='repeat_new_password.status'>
						<div class="col-md-12">
							<input type="password" v-model="repeat_new_password.value" class="form-control" required>
							<span v-if='repeat_new_password.status == "has-error"' class="glyphicon glyphicon-remove form-control-feedback"></span>
							<span v-if='repeat_new_password.status == "has-success"' class="glyphicon glyphicon-ok form-control-feedback"></span>
						</div>
					</div>
					<alert :type='change_result.status'>{{change_result.value}}</alert>
				</tab>
			</tabs>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-default" @click='showUserModal = false'>Отмена</button>
				<button v-if='activeTab == 0' type="button" class="btn btn-primary" @click="logout">Выйти</button>
				<button v-if='activeTab == 1' type="button" class="btn btn-primary" @click='changePassword'>Сменить пароль</button>
			</div>
		</modal>

		<modal title='' v-model="showHelpModal" @ok="showHelpModal = false" :backdrop='false' medium>
			<a :href='help'>Руководство пользователя</a>
			<hr>
			<div style="margin-bottom: 15px">
				При возникновении трудностей с заполнением системы обращайтесь по номеру 8-495-993-34-07 доб. 156
			</div>
			<div style="margin-bottom: 15px">
				Анисимова Анастасия Игоревна  - заместитель начальника отдела оценки назначения мероприятий по защите лесов
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click='showHelpModal = false'>Ок</button>
			</div>
		</modal>

		<modal title='Ошибка формирования заключения' v-model="showIncorrectDataGroupConclusion" @ok="showIncorrectDataGroupConclusion = false" :backdrop='false' medium>
			<div style="margin-bottom: 15px">
				{{incorrectDataGroupConclusionMessage}}
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click='showIncorrectDataGroupConclusion = false'>Ок</button>
			</div>
		</modal>

		<modal title='Доступные для выгрузки типы заключения' v-model="displayPossibleConclusionTypes" @ok="displayPossibleConclusionTypes = false" :backdrop='false' medium>
				<div class="row" style="margin-bottom: 10px; line-height: 30px;">
					<div class="col col-md-6 text-right-important">
						Заключение - ВСР, ССР, УНД
					</div>
					<div class="col col-md-4">
						<button class="btn btn-primary" @click='generate_ssr_vsr_und_conclusion' :disabled="!possibleConclusionTypes.ssr_vsr_und">
							Выгрузить
						</button>
					</div>
				</div>
				<div class="row" style="margin-bottom: 10px; line-height: 30px;">
					<div class="col col-md-6 text-right-important">
						Заключение - АМ, ПМ, РАД
					</div>
					<div class="col col-md-4">
						<button class="btn btn-primary" @click='generate_am_pm_rad_conclusion' :disabled="!possibleConclusionTypes.am_pm_rad">
							Выгрузить
						</button>
					</div>
				</div>
				<div class="row" style="line-height: 30px;">
					<div class="col col-md-6 text-right-important">
						Заключение - Б.Н.
					</div> 
					<div class="col col-md-4">
						<button class="btn btn-primary" @click='generate_bn_conclusion' :disabled="!possibleConclusionTypes.bn">
							Выгрузить
						</button>
					</div>
				</div>
			
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click='displayPossibleConclusionTypes = false'>Отмена</button>
			</div>
		</modal>

		<modal title='Доступные для выгрузки типы заключения на группу актов' v-model="displayPossibleConclusionTypesGroup" @ok="displayPossibleConclusionTypesGroup = false" :backdrop='false' medium>
				<div class="row" style="margin-bottom: 10px; line-height: 30px;">
					<div class="col col-md-6 text-right-important">
						Заключение - ВСР, ССР, УНД
					</div>
					<div class="col col-md-4">
						<button class="btn btn-primary" @click='generate_ssr_vsr_und_for_group_conclusion' :disabled="!possibleConclusionTypesGroup.ssr_vsr_und">
							Выгрузить
						</button>
					</div>
				</div>
				<div class="row" style="margin-bottom: 10px; line-height: 30px;">
					<div class="col col-md-6 text-right-important">
						Заключение - АМ, ПМ, РАД
					</div>
					<div class="col col-md-4">
						<button class="btn btn-primary" @click='generate_am_pm_rad_for_group_conclusion' :disabled="!possibleConclusionTypesGroup.am_pm_rad">
							Выгрузить
						</button>
					</div>
				</div>
				<div class="row" style="line-height: 30px;">
					<div class="col col-md-6 text-right-important">
						Заключение - Б.Н.
					</div> 
					<div class="col col-md-4">
						<button class="btn btn-primary" @click='generate_bn_for_group_conclusion' :disabled="!possibleConclusionTypesGroup.bn">
							Выгрузить
						</button>
					</div>
				</div>
			
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click='displayPossibleConclusionTypesGroup = false'>Отмена</button>
			</div>
		</modal>

		<edit-reports-modal :show='showEditReportsModal' @close='showEditReportsModal = false'/>

		<div v-if="displayImportingModal" class="importing_modal_bg">
			<div class="importing_modal_content">
				<div>Идёт обработка акта.</div>
				<div>Пожалуйста, подождите...</div>
				<i class='fa fa-spinner fa-spin' style='font-size:48px;'></i>
			</div>
		</div>

	</div>
</template>

<script>
	require('vue-strap/dist/vue-strap-lang.js')
	
	import router from '../router'
	import auth from '../auth'
	import { EventBus } from '../lib/EventBus'
	import {DB} from '../constants'
	import {HELP} from '../constants'

	// import $ from 'jquery';

	import { navbar,dropdown,datepicker,modal,tabs,tab,alert } from 'vue-strap'
	import moment from 'moment'

	import EditReportsModal from './EditReportsModal.vue'

	const CAN_EDIT = 'can_edit_unit.php'
	const GET_NAME = 'get_name.php'
	const CHANGE_PASSWORD = 'change_password.php'
	const GET_USER_REPORTS = 'get_user_reports.php'
	const CAN_REG_USER = 'can_reg_user.php'
	const GET_AVALIABLE_UNITS = 'get_avaliable_units.php'
	//const GENERATE_CONCLUSION = 'report_the_conclusion.php'

	const GENERATE_CONCLUSION_SSR_VSR_UND = 'report_the_conclusion.php'
	const GENERATE_CONCLUSION_AM_PM_RAD = 'report_the_conclusion_am_pm_rad.php'
	const GENERATE_CONCLUSION_BN = 'report_the_conclusion_bn.php'

	const GENERATE_CONCLUSION_SSR_VSR_UND_FOR_GROUP = 'report_the_conclusion_for_group.php'
	const GENERATE_CONCLUSION_AM_PM_RAD_FOR_GROUP = 'report_the_conclusion_am_pm_rad_for_group.php'
	const GENERATE_CONCLUSION_BN_FOR_GROUP = 'report_the_conclusion_bn_for_group.php'

	const GET_POSSIBLE_CONLUSION_TYPES = 'get_possible_conclusion_types.php'
	const GET_POSSIBLE_CONLUSION_TYPES_FOR_GROUP = 'get_possible_conclusion_types_group.php'
	const CAN_CHANGE_CONCLUSION_USER = 'can_change_conclusion_user.php'
	const MAKE_GROUP = 'make_group.php'
	const GET_GROUP = 'get_group.php'
	const MAKE_GROUP_FROM_FILTER = 'make_group_from_filter.php'

	const CAN_EDIT_WARRNAT = 3
	const CAN_EDIT_REPORTS_ID = 8
	const CAN_EDIT_ADDRESS = 9

	const IMPORT_XML = 'import_xml.php'

	/*const REPORT_WEEK = 'report_week.php'
	const REPORT_CONCLUSION = 'report_conclusion.php'
	const REPORT_SOM = 'report_som.php'*/

	export default {
		name: 'main',
		data () {
			return {
				id: 1,
				act_id: null,
				selected: 0,
				db: DB,

				lastJournalURL: '/main',

				supervisory_id: null,
				supervisory_obj: null,

				editPath: '',
				conclusionPath: '',
				warrantPath: '',
				supervisionPath: '#/main/supervision',
				help: HELP,

				/*can_edit_act: false,
				can_edit_conclusion: false,
				can_edit_warrant: false,*/

				can_create_act: false,
				can_reg_user: false,

				value: '',
				format: 'dd.MM.yyyy',

				user_name: '',
				showUserModal: false,
				showHelpModal: false,
				activeTab: 0,
				old_password: {status: 'default', value: ''},
				new_password: {status: 'default', value: ''},
				repeat_new_password: {status: 'default', value: ''},
				change_result: {status: 'default', value: ''},
				avaliable_units: [],
				showEditReportsModal: false,

				can_change_pass: false,
				can_save_db: false,

				filter: [],
				selected_filters: {},
				filter_drafts: [],
				selected_filters_drafts: {},
				filter_states: [],
				selected_filters_states: {},
				filter_decisions: [],
				selected_filters_decisions: {},

				filter_supervisory: [],
				selected_filters_supervisory: {},

				reports: [],
				currentPath: '',

				loading: false,
				showIncorrectDataGroupConclusion: false,
				incorrectDataGroupConclusionMessage: '',

				makeGroupFromFilterDisabled: true,
				displayPossibleConclusionTypes: false,
				displayPossibleConclusionTypesGroup: false,
				possibleConclusionTypes: {
					ssr_vsr_und: false,
					am_pm_rad: false,
					bn: false
				},
				possibleConclusionTypesGroup: {
					ssr_vsr_und: false,
					am_pm_rad: false,
					bn: false
				},
				displayImportingModal: false
				/*
					showWeekModal: false,
					startWeekDate: moment().subtract(7,'days').format('DD.MM.YYYY'),
					endWeekDate: moment().format('DD.MM.YYYY'),

					showConclusionModal: false,
					startConclusionDate: moment().subtract(7,'days').format('DD.MM.YYYY'),
					endConclusionDate: moment().format('DD.MM.YYYY'),

					showSomModal: false,
					startSomDate: moment().subtract(7,'days').format('DD.MM.YYYY'),
					endSomDate: moment().format('DD.MM.YYYY'),
				*/
			}
		},
		components: {
			EditReportsModal,
			navbar,
			dropdown,
			datepicker,
			modal,
			tabs,
			tab,
			alert
		},
		computed: {
			canEditReports () {
				for(let unit of this.avaliable_units) {
					if(unit.id == CAN_EDIT_REPORTS_ID)
						return true
				}
				return false
			},
			canEditWarrant() {
				for(let unit of this.avaliable_units) {
					if(unit.id == CAN_EDIT_WARRNAT)
						return true
				}
				return false
			},
			canEditAddress() {
				for(let unit of this.avaliable_units) {
					if(unit.id == CAN_EDIT_ADDRESS)
						return true
				}
				return false
			},
			canDeleteAct() {
				for(let unit of this.avaliable_units) {
					if(unit.id == 10) //10 - удаление
						return true && Boolean(this.act_id)
				}
				return false
			},
			displayTheConclusion () {
				let found = this.reports.find(e => {
					return e.id == 6 //
				})
				return found && this.act_id
			},
			isReport () {
				const names = ['editReports', 'reports', 'Monitoring', 'ConclusionReport', 'Mzl', 'MonitoringRlh', 'NpaMzl', 'WarrantsCount']
				return names.includes(this.currentPath)
			},
			groupDisabled () {
				// return true
				return !(this.act_id || this.currentPath == "list" || this.currentPath == "group_conclusion")
			},
		},
		watch: {
			'$route.name': function (str) {
				this.currentPath = str
			}
		},
		methods: {
			logout: function () {
				document.body.removeAttribute('style')
				auth.logout()
				router.replace('/login')
			},
			importAct () {
				this.$refs.xml_input.click()
			},
			changeXmlFile(event) {
				if(event.target.files && event.target.files[0]) {
					this.displayImportingModal = true
					let formData = new FormData()
					formData.append('xml', event.target.files[0])

					event.target.value = ''

					fetch(DB + IMPORT_XML, {
						method: 'post',
						body: formData,
						credentials: 'include'
					})
					.then(res => res.json())
					.then(json => {
						this.displayImportingModal = false
						router.push({ name: 'add', params: json })
					})
					.catch(e => {
						this.displayImportingModal = false
					})
				}
			},
			changePassword () {
				// this.new_password.status = 'has-success'
				// this.old_password.status = 'has-error'

				if (this.old_password.value === '') {
					this.old_password.status='has-error'
					this.change_result.value = 'Вы должны ввести старый пароль'
					this.change_result.status = 'danger'
				}
				else if (this.new_password.value === '') {
					this.new_password.status='has-error'
					this.change_result.value = 'Вы должны ввести новый пароль'
					this.change_result.status = 'danger'
				}
				else if (this.repeat_new_password.value === '') {
					this.repeat_new_password.status='has-error'
					this.change_result.value = 'Вы должны ввести подтверждение пароля'
					this.change_result.status = 'danger'
				} else if (this.new_password.value !== this.repeat_new_password.value) {
					this.change_result.value = 'Подтверждение не совпадает с паролем'
					this.change_result.status = 'danger'
					this.new_password.status='has-error'
					this.repeat_new_password.status='has-error'
					this.old_password.status=''
				}
				else {
					this.new_password.status='has-success'
					this.repeat_new_password.status='has-success'

					let form = new FormData()
					form.append('old', this.old_password.value)
					form.append('new', this.new_password.value)

					fetch(DB + CHANGE_PASSWORD, {
						credentials: 'include',
						method: 'post',
						body: form
					})
					.then(res => res.json())
					.then(res => {
						if (res) {
							switch (res[0].code) {
								case '1':
									this.old_password.status = 'has-error'
									this.change_result.status = 'danger'
									break
								case '0':
									this.old_password.status = 'has-success'
									this.change_result.status = 'success'
									break
								default:
									this.old_password.status = ''
									break
							}
							this.change_result.value = res[0].name
						}
					})
					.catch(err => console.log(err))
				}
			},
			clearModal () {
				this.old_password.value = ''
				this.new_password.value = ''
				this.repeat_new_password.value = ''

				this.old_password.status = 'default'
				this.new_password.status = 'default'
				this.repeat_new_password.status = 'default'

				this.change_result.value = ''
				this.change_result.status = ''
			},
			makeGroup () {
				fetch(DB + MAKE_GROUP + '?act_id=' + this.act_id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					//console.log(res)
					const group_id = res[0].czl_make_group

					router.push('/main/group_conclusion/' + group_id)

				})
				.catch(err => console.log(err))
			},
			makeGroupFromFilter () {
				//if(this.makeGroupFromFilterDisabled)
				//	return false

				let where = '('
				for (let f in this.selected_filters) {
					if(this.selected_filters[f]) {
						if(f == 'act_placement_date' && this.selected_filters[f].value.length == 2) {
								const from = this.selected_filters[f].value[0]
								const to = this.selected_filters[f].value[1]
								where += `act_placement_date BETWEEN '${from}' AND '${to}'  or `
						} else {
							for (let i = 0; i < this.selected_filters[f].value.length; i++) {
								if(this.selected_filters[f])
									where += this.selected_filters[f].value[i] !== '' ? `${f}='${this.selected_filters[f].value[i]}' or ` : `${f} is null or `
							}
						}
					}
					where = this.selected_filters[f].length !== 0 ? where.slice(0,-4) : where
					if(this.selected_filters[f])
						where += this.selected_filters[f].value.length !== 0 ? ') and (' : ''					
				}
				where = where.slice(0,-6)
				
				fetch(DB + MAKE_GROUP_FROM_FILTER + '?filter=' + where, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					//console.log(res)
					const group_id = res[0].czl_make_group_from_journal

					if(group_id == -1)
						window.alert('Не найдено актов, которые можно объединить в группу')
					else
						router.push('/main/group_conclusion/' + group_id)

				})
				.catch(err => console.log(err))
			},
			generate_conclusion() {
				fetch(`${DB}${GET_POSSIBLE_CONLUSION_TYPES}?ids=${this.act_id}`, {credentials: 'include'})
				.then(res => res.json())
				.then(json => {
					this.displayPossibleConclusionTypes = true
					this.possibleConclusionTypes.ssr_vsr_und = false
					this.possibleConclusionTypes.am_pm_rad = false
					this.possibleConclusionTypes.bn = false
					if(json)
						for(let type of json) {
							if(type.id == 1)
								this.possibleConclusionTypes.ssr_vsr_und = true
							if(type.id == 2)
								this.possibleConclusionTypes.am_pm_rad = true
							if(type.id == 3)
								this.possibleConclusionTypes.bn = true

						}
					//console.warn(json)
				})
				//window.location.href=`${DB}${GENERATE_CONCLUSION}?act_id=${this.act_id}`
			},
			generate_ssr_vsr_und_conclusion() {
				window.location.href=`${DB}${GENERATE_CONCLUSION_SSR_VSR_UND}?act_id=${this.act_id}`
			},
			generate_am_pm_rad_conclusion() {
				window.location.href=`${DB}${GENERATE_CONCLUSION_AM_PM_RAD}?act_id=${this.act_id}`
			},
			generate_bn_conclusion() {
				window.location.href=`${DB}${GENERATE_CONCLUSION_BN}?act_id=${this.act_id}`
			},
			generate_ssr_vsr_und_for_group_conclusion() {
				window.location.href=`${DB}${GENERATE_CONCLUSION_SSR_VSR_UND_FOR_GROUP}?act_id=${this.act_id}`
			},
			generate_am_pm_rad_for_group_conclusion() {
				window.location.href=`${DB}${GENERATE_CONCLUSION_AM_PM_RAD_FOR_GROUP}?act_id=${this.act_id}`
			},
			generate_bn_for_group_conclusion() {
				window.location.href=`${DB}${GENERATE_CONCLUSION_BN_FOR_GROUP}?act_id=${this.act_id}`
			},
			get_possible_conclusion_for_group() {
				fetch(`${DB}${GET_POSSIBLE_CONLUSION_TYPES_FOR_GROUP}?ids=${this.act_id}`, {credentials: 'include'})
				.then(res => res.json())
				.then(json => {
					console.warn(json)
					if(json) {
						if(json.error) {
							this.incorrectDataGroupConclusionMessage = json.error;
							this.showIncorrectDataGroupConclusion = true;
							return;
						} else {
							this.displayPossibleConclusionTypesGroup = true
							this.possibleConclusionTypesGroup.ssr_vsr_und = false
							this.possibleConclusionTypesGroup.am_pm_rad = false
							this.possibleConclusionTypesGroup.bn = false

							for(let type of json) {
								if(type.id == 1)
									this.possibleConclusionTypesGroup.ssr_vsr_und = true
								if(type.id == 2)
									this.possibleConclusionTypesGroup.am_pm_rad = true
								if(type.id == 3)
									this.possibleConclusionTypesGroup.bn = true
							}
						}		
					}
				})
			},
			generate_conclusion_for_group() {
				this.loading = true;

				//console.log('generate conclusion for group');
				const url = DB + GENERATE_CONCLUSION_FOR_GROUP;//?act_id=${this.act_id}`;
				// window.location.href = url;

				const form = new FormData();
				form.append('act_id', this.act_id);

				fetch(url, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(data => data.json())
				.then(data => {
					//console.log('data');
					//console.log(data);
					this.loading = false;

					if (data.code == -1) {
						this.incorrectDataGroupConclusionMessage = data.message;
						this.showIncorrectDataGroupConclusion = true;
						this.loading = false;
						return;
					}

					const a = document.createElement('a');
					a.setAttribute('href', data.file);
					document.body.append(a);
					a.setAttribute("download",data.name);
					a.click();
					a.parentElement.removeChild(a);
					this.loading = false;
				});
			},
			showSimilarActs () {
				EventBus.$emit('showSimilarActs')
			},
			deleteAct() {
				if(this.act_id) {
					const c = confirm("Вы уверены, что хотите удалить акт? Это действие является необратимым.")
					if(c) {
						let formData = new FormData()
						formData.append('act_id', this.act_id)

						fetch(DB + 'delete_act.php', {
							method: 'post',
							body: formData,
							credentials: 'include'
						})
						.then(res => res.json())
						.then(json => {
							if(json) {
								if(json.Error) {
									alert('Произошла ошибка при удалении акта. ' + json.Error)
								} else {
									EventBus.$emit('delete_act')
								}
							}
						})
					}
				}
			}
		},
		mounted () {
			this.currentPath = this.$route.name
		},
		created () {
			window.onresize = (e) => {
				if(window.timeout_id)
					clearTimeout(window.timeout_id)

				window.timeout_id = setTimeout(() => {
					document.body.style = 'padding-top: ' + document.querySelector('nav').offsetHeight + 'px;'
				}, 100)
			}
			EventBus.$on('act_id', id => {
				this.editPath = `#/main/edit/${id}`
				this.conclusionPath = `#/main/conclusion/${id}`
				this.warrantPath = `#/main/warrant/${id}`
				this.act_id = id
			})

			EventBus.$on('supervisory_id', obj => {
				this.supervisionPath = `#/main/supervision/${obj.id}`;
				this.supervisory_id = obj.id;
				this.supervisory_obj = obj;

				/*console.log('--------------');
				console.log('supervisory event');
				console.log(this.supervisory_obj.id);
				console.log(this.supervisory_obj);
				console.log('--------------');*/

			});

			/* EventBus.$on('save-filter', data => {
				this.filter = data.f
				if(data.name)
					this.selected_filters[data.name] = data.s
			}) */

			EventBus.$on('save-page', num => {
				this.page_num = num
			})

			EventBus.$on('filter', f => {
				this.selected_filters[f.field] = {}
				this.selected_filters[f.field].value = f.value
				this.selected_filters[f.field].filtered = f.filtered
				if(
					this.selected_filters.fo && this.selected_filters.fo.value && this.selected_filters.fo.value.length == 1 &&
					this.selected_filters.region && this.selected_filters.region.value && this.selected_filters.region.value.length == 1 &&
					this.selected_filters.forestry && this.selected_filters.forestry.value && this.selected_filters.forestry.value.length == 1
					) {
					this.makeGroupFromFilterDisabled = false
				} else {
					this.makeGroupFromFilterDisabled = true
				}
			})
			// ---------------------------------------
			/* EventBus.$on('save-filter-drafts', data => {
				this.filter_drafts = data.f
				this.selected_filters_drafts[data.name] = data.s
			}) */

			EventBus.$on('save-page-drafts', num => {
				this.page_num_drafts = num
			})

			EventBus.$on('filter-drafts', f => {
				this.selected_filters[f.field + '-drafts'] = {}
				this.selected_filters[f.field + '-drafts'].value = f.value
				this.selected_filters[f.field + '-drafts'].filtered = f.filtered
			})
			// ---------------------------------------
			/*EventBus.$on('save-filter-states', data => {
				this.filter_states = data.f
				this.selected_filters_states[data.name] = data.s
			})*/

			EventBus.$on('save-page-states', num => {
				this.page_num_states = num
			})

			EventBus.$on('filter-states', f => {
				this.selected_filters[f.field + '-states'] = {}
				this.selected_filters[f.field + '-states'].value = f.value
				this.selected_filters[f.field + '-states'].filtered = f.filtered
			})
			// ---------------------------------------
			/*EventBus.$on('save-filter-decisions', data => {
				this.filter_decisions = data.f
				this.selected_filters_decisions[data.name] = data.s
			})*/

			EventBus.$on('save-page-decisions', num => {
				this.page_num_decisions = num
			})

			EventBus.$on('filter-decisions', f => {
				this.selected_filters[f.field + '-decisions'] = {}
				this.selected_filters[f.field + '-decisions'].value = f.value
				this.selected_filters[f.field + '-decisions'].filtered = f.filtered
			})

			// ---------------------------------------
		/* 	EventBus.$on('save-filter-interactions', data => {
				this.filter_interactions = data.f
				this.selected_filters_interactions[data.name] = data.s
			})

			EventBus.$on('save-page-interactions', num => {
				this.page_num_interactions = num
			})

			EventBus.$on('filter-interactions', f => {
				this.selected_filters_interactions[f.field + '-interactions'] = {}
				this.selected_filters_interactions[f.field + '-interactions'].value = f.value
				this.selected_filters_interactions[f.field + '-interactions'].filtered = f.filtered
			}) */
			// ---------------------------------------
			/* EventBus.$on('save-filter-supervisory', data => {
				this.filter_supervisory = data.f
				this.selected_filters_supervisory[data.name] = data.s
			}) */

			EventBus.$on('save-page-supervisory', num => {
				this.page_num_supervisory = num
			})

			EventBus.$on('filter-supervisory', f => {
				this.selected_filters[f.field + '-supervisory'] = {}
				this.selected_filters[f.field + '-supervisory'].value = f.value
				this.selected_filters[f.field + '-supervisory'].filtered = f.filtered
			})

			/*EventBus.$on('can_edit', data => {
				this.can_edit_act = data.act === 't' ? true : false
				this.can_edit_conclusion = data.conclusion === 't' ? true : false
				this.can_edit_warrant = data.warrant === 't' ? true : false
			})*/


			fetch(DB + GET_AVALIABLE_UNITS, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.avaliable_units = res || []
			})
			.catch(err => console.log(err))

			fetch(DB + CAN_EDIT + '?act_id=0&unit_id=1', { //Can create act?
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.can_create_act = res[0].czl_check_can_edit_unit !== null ? true : false
			})
			.catch(err => console.log(err))

			fetch(DB + CAN_REG_USER, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.can_reg_user = res[0].czl_check_can_reg_user == 't' ? true : false
			})
			.catch(err => console.log(err))

			fetch(DB + GET_USER_REPORTS, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if(res)
				{
					this.reports = res
				}
				else
					this.reports = []
			})
			.catch(err => console.log(err))


			fetch(DB + GET_NAME, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.user_name = res[0].name
			})
			.catch(err => console.log(err))

			fetch(DB + CAN_CHANGE_CONCLUSION_USER, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res =>{
				this.can_save_db = (res[0].value == 't')
			})

			this.can_change_pass = auth.user.id === '42'

		},
		beforeDestroy () {
			window.onresize = () => {}
			EventBus.$off('act_id')
			EventBus.$off('supervisory_id');
			//EventBus.$off('can_edit')
			EventBus.$off('save-filter')
			EventBus.$off('save-page')
			EventBus.$off('save-filter-drafts')
			EventBus.$off('save-page-drafts')
			EventBus.$off('save-page-supervisory')
			EventBus.$off('filter')
			EventBus.$off('filter-drafts')
			EventBus.$off('filter-supervisory')
		}
	}
</script>

<style>
.text-right-important {
	text-align: right !important;
}

.field-error {
	border: solid 1px red !important;
}

.field-success {
	border-right: none !important;
	border-left: solid 1px;
	border-top: solid 1px;
	border-bottom: solid 1px;
}

.place-success {
	/*border-bottom: none !important;*/
	border-right: none !important;
	border-top: 1px solid black !important;
}

.table_body_wrap {
	overflow-y: scroll;
	max-height: 60vh;
}

.place_table td.form_td {
	font-size: 9px;
	width: 7%;
}

.place_table tr, .place_table th.form_td{
	text-align: center;
	font-size: 9px;		
	width: 7%;
}

.place_table td.form_td_chkbox {
	width: 1%;
	border-right: none;
}

.place_table th.form_td_chkbox {
	width: 1%;
	border-bottom: 1px solid;
}

.place_table {
	margin-bottom: 5px;
	/*border: 1px solid;*/
	width: 100%;
	table-layout: fixed;
}

.place_table thead, .place_table tbody, .place_table tr {
	border: none;
}

.place_table .table-control {
	font-size: 9px !important;
}

.place_table__top,
.conclusion_place_table__top,
.warrant_place_table__top {
	margin-bottom: 0px !important;
	/*border-bottom: 1px solid !important;*/
}

.place_table__bottom,
.conclusion_place_table__bottom,
.warrant_place_table__bottom {
	/*border-top: none !important;*/
}

/*.table_body_wrap table tr:first-child td {
	border-top: none !important;
	/*border-bottom: 1px solid;
    margin-bottom: -1px;
}*/

.conclusion_place_table,
.warrant_place_table {
	table-layout: fixed;
}

.place_table__top .form_td_chkbox,
.conclusion_place_table__top .form_td_chkbox {
	/*border-bottom: none !important;*/
}

	div.datepicker.table-control > input.form-control {
		border: none !important;
		height: 24px;
		margin: 0px;
		display: inline-table !important;
		font-size: 12px !important;
	}

	.divider {
		border-left: 2px solid antiquewhite;
		height: 30px;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.bold {
		font-weight: bold;
	}

	.pull-left {
		text-align: left;
	}

	.main {
		margin: 15px;
	}

	form.form {
		font-size: 12px;
		/*margin: 10px;
		padding: 5px; */
	}

	h4 {
		text-align: center;
	}

	select.form-control:not([size]):not([multiple]) {
		height: 24px;
	}

	.form-control {
		padding-left: 5px;
		padding-top: 0px;
		padding-bottom: 0px;
		margin-bottom: 5px;
		height: 24px;
		display: inline-table;
		font-size: 12px;
	}

	.height-control {
		height: 24px !important;
	}


	.row {
		vertical-align: middle;
	}

	.col {
		padding-right: 15px;
		padding-left: 15px;
		text-align: center;
	}

	.checkbox {
		vertical-align: middle;
	}

	.table-control {
		height: 25px;
		width: 100%;
		margin: 0px;
		border: none;
	}

	.table-mzl {
		width: 100%;
		margin-bottom: 10px;
	}

	.table-mzl th {
		text-align: center;
	}

	.table-mzl td {
		width: 1%;
		background-color: #eee;
	}

	.medium {
		width: 100px !important;
	}

	.short {
		width: 50px !important;
	}

	.short_plus {
		width: 70px !important;
	}

	input[type='checkbox'].checkbox,
	#chkBoxSelAll {
		margin: 0 auto !important;
		width: 12px;
		height: 12px;
	}

	.btnPanel {
		text-align: right;
	}
	
	.documentsTable tr {
		border: none;
	}
	
	.documentsTable th {
		border-bottom: none;
		border-top: solid 1px;
		border-left: solid 1px;
		border-right: solid 1px;
	}

	.documentsTable td {
		border: solid 1px;
		width: 25%;
	}

	.documentsTable th {
		text-align: center;
	}

	.documentsTable {
		width: 100%;
	}

.dateTable, .dateTable td {
	border: solid 1px ;
	text-align: center;
}

.dateTable th {
	border-top: solid 1px;
	border-left: solid 1px;
	border-right: solid 1px;
	border-bottom: none !important;
	text-align: center;
}

.dateTable tr, .dateTable thead, .dateTable tbody {
	border: none;
}

.dateTable {
	width: 100%;
}

	h4 {
		font-size: 24px;
		margin-top: 0px;
	}

	.btn-secondary {
		border-color: #ccc !important;
	}

	.colspan_td {
		text-align: center;
	}
	
	.navbar-inverse .navbar-nav > li > a, .navbar-inverse .navbar-text, .navbar-brand {
		color: #fff !important;
	}

	.navbar-inverse,
	.navbar-inverse .navbar-toggle:hover,
	.navbar-inverse .navbar-nav > .open > a,
	.navbar-inverse .navbar-nav > .open > a:hover,
	.navbar-inverse .navbar-nav > .open > a:focus {
		background-color: #0275d8 !important;
		border-color: #0275d8 !important;
	}

	.navbar-inverse > .container {
		width: 90% !important;
	}

	.disabled-link {
		color: gray !important;
	}

/* 	.modal-dialog {
	width: 300px !important;
} */

.center {
	text-align: center;
}

.large-font {
	font-size: 16px;
}

.form-control-feedback {
	top: -6px;
	right: 11px !important;
}

[tabs] > .tab-content, .alert {
	margin-bottom: 0px;
}

.btn-header {
	margin-top: 7px;
}

.pointer:hover {
	cursor: pointer;
}

.list_wrapper {
	margin-top: 5px !important;
}

.list-title {
	font-size: 20px;
	margin-bottom: 5px;
}
</style>

<style scoped>
	li.disabled > a {
		color: #c1c1c1 !important;
	}
	.underlined { 
		box-shadow: inset 5px -10px 0px 0px rgb(2, 117, 216), 
		inset -5px -10px 0px 0px rgb(2, 117, 216), 
		inset 0px -13px 0px 0px rgb(255, 255, 255)
	}
/*	.navbar-default {
		background-color: #0275d8;
		border-color: #0275d8;
	}

	.navbar-default .navbar-brand {
		color: #ecf0f1;
	}
	.navbar-default .navbar-brand:hover,
	.navbar-default .navbar-brand:focus {
		color: #ffffff;
	}
	.navbar-default .navbar-text {
		color: #ecf0f1;
	}
	.navbar-default .navbar-nav > li > a {
		color: #ecf0f1;
	}
	.navbar-default .navbar-nav > li > a:hover,
	.navbar-default .navbar-nav > li > a:focus {
		color: #ffffff;
	}
	.navbar-default .navbar-nav > .active > a,
	.navbar-default .navbar-nav > .active > a:hover,
	.navbar-default .navbar-nav > .active > a:focus {
		color: #ffffff;
		background-color: #0275d8;
	}
	.navbar-default .navbar-nav > .open > a,
	.navbar-default .navbar-nav > .open > a:hover,
	.navbar-default .navbar-nav > .open > a:focus {
		color: #ffffff;
		background-color: #0275d8;
	}
	.navbar-default .navbar-toggle {
		border-color: #0275d8;
	}
	.navbar-default .navbar-toggle:hover,
	.navbar-default .navbar-toggle:focus {
		background-color: #0275d8;
	}
	.navbar-default .navbar-toggle .icon-bar {
		background-color: #ecf0f1;
	}
	.navbar-default .navbar-collapse,
	.navbar-default .navbar-form {
		border-color: #ecf0f1;
	}
	.navbar-default .navbar-link {
		color: #ecf0f1;
	}
	.navbar-default .navbar-link:hover {
		color: #ffffff;
	}

	@media (max-width: 767px) {
		.navbar-default .navbar-nav .open .dropdown-menu > li > a {
			color: #ecf0f1;
		}
		.navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,
		.navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
			color: #ffffff;
		}
		.navbar-default .navbar-nav .open .dropdown-menu > .active > a,
		.navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,
		.navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {
			color: #ffffff;
			background-color: #0275d8;
		}
	}

	.container {
		width: 90%;
	}*/

	.loading-wrap {
		position: absolute;
	    left: 0;
	    right: 0;
	    z-index: 1000;
	    top: 0;
	    bottom: 0;
	    background: rgba(255,255,255,0.8);
	    display: flex;
    	align-items: center;
    	justify-content: center;
	} 

	.xml_input {
		display: none;
	}

	.importing_modal_bg {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		display: flex;
		background-color: rgba(0,0,0,0.5);
		z-index: 10000;
		align-items: center;
    	justify-content: center;
	}

	.importing_modal_content {
		width: 350px;
		height: 250px;
		background-color: #fff;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 20px;
	}

</style>


// WEBPACK FOOTER //
// Main.vue?8ccdd634